export enum orgFeatures {
    showPayments = 'showPayments',
    showUsage = 'showUsage',
    brandedPublicPlaybooks = 'brandedPublicPlaybooks',
    enableExtendedInsights = 'enableExtendedInsights',
    disableExternalSharing = 'disableExternalSharing',
    enableKafkaForAnalytics = 'enableKafkaForAnalytics',
    overrideAllowedLanguages = 'overrideAllowedLanguages',
    isAskGuiddeShown = 'isAskGuiddeShown',
    uploadSubtitles = 'uploadSubtitles',
    useVoiceOver = 'useVoiceOver',
    showBrandKitPage = 'showBrandKitPage',
    showApplicationsTab = 'showApplicationsTab',
    showQGRecordOnly = 'showQGRecordOnly',
    allowMagicCapture = 'allowMagicCapture',
    showMagicCaptureLanguages = 'showMagicCaptureLanguages',
}

export enum globalFeatures {
    qgTransitions = 'qgTransitions',
    useKafkaEvents = 'useKafkaEvents',
    qgExtensionUseCapture = 'qgExtensionUseCapture',
}

export type FeatureFlagsGlobalType = {
    [key in globalFeatures]: boolean
}

export type FeatureFlagsType = {
    [key in orgFeatures]: boolean
}
